import { EventInput } from '@fullcalendar/common';
import { ResourceInput } from '@fullcalendar/resource-common';
import { ifPresent } from '@/shared/utils/typescript';
import { DEFAULT_PLANNER_EVENT_DURATION, PLANNER_DATE_FORMAT, PLANNER_DATE_TIME_FORMAT, PLANNER_TIME_FORMAT } from '../constants/general';
import Break from '../models/Break';
import PlannerCalendarEvent from '../models/PlannerCalendarEvent';
import PlannerEvent from '../models/PlannerEvent';
import PlannerResource from '../models/PlannerResource';

export function wrapCalendarEvent(event: PlannerCalendarEvent): EventInput {
  return {
    start: event.date.format(PLANNER_DATE_FORMAT),
    extendedProps: {
      original: event,
    },
  };
}

export function wrapPlannerEvent(event: PlannerEvent, ignoreLock: boolean): EventInput {
  return {
    id: ifPresent(event.id, id => `${id}`),
    resourceId: ifPresent(event.resourceId, id => `${id}`),
    start: event.start?.format(PLANNER_DATE_TIME_FORMAT),
    end: event.end?.format(PLANNER_DATE_TIME_FORMAT),
    editable: event.editable || ignoreLock,
    create: false,
    duration: event.plannedDuration || DEFAULT_PLANNER_EVENT_DURATION,
    extendedProps: {
      original: event,
    },
  };
}

export function wrapBreak(event: Break): EventInput {
  return {
    resourceId: `${event.resourceId}`,
    daysOfWeek: event.daysOfWeek,
    startTime: event.start.format(PLANNER_TIME_FORMAT),
    endTime: event.end.format(PLANNER_TIME_FORMAT),
    extendedProps: {
      original: event,
    },
  };
}

export function wrapResource(resource: PlannerResource): ResourceInput {
  return {
    id: `${resource.id}`,
    title: resource.fullName,
    businessHours: resource.businessHours.map(b => ({
      daysOfWeek: b.daysOfWeek,
      startTime: b.start.format(PLANNER_TIME_FORMAT),
      endTime: b.end.format(PLANNER_TIME_FORMAT),
    })),
    extendedProps: {
      original: resource,
    },
  };
}
